// extracted by mini-css-extract-plugin
export var attachment = "_jq-a";
export var emailContainer = "_jq-4";
export var emailContentPaddedContainer = "_jq-b";
export var emailHeader = "_jq-6";
export var emailIframe = "_jq-3";
export var emailInfoIcon = "_jq-9";
export var emailShortenedSummary = "_jq-e";
export var infoDropdown = "_jq-0";
export var infoRowBoundedContent = "_jq-d";
export var internal = "_jq-5";
export var merchant = "_jq-8";
export var messageInputContainer = "_jq-h";
export var normal = "_jq-7";
export var replyCard = "_jq-f";
export var subtleButton = "_jq-1";
export var subtleButtonIconContainer = "_jq-2";
export var toggleViewRepliesButton = "_jq-c";
export var wrappingText = "_jq-g";